import type { ReportLayoutConfig, SectionBuild } from '../models/layoutConfig.types'

// v3 `configs/Travel/HotelAds.js` (35 ln). Mapping applied (the reference port for ORP-18652):
// `tabs` → `scheduleTabs` (fields derive from schedule metadata until ORP-18643),
// `visibleType: 'double'` → chart-table composition, `defaultFilters` → `filters`,
// `chartSortMetric` folds into `sortField` (v4 charts sort by the active sort),
// `chartLineColumn` was dead in v3 (never a declared prop) and stays dropped,
// `channel` (logo hint) is section-chrome in v4, not a DataVisible prop.

const HOTEL_ADS_REPORT_ID = 69

const hotelAdsBuild: SectionBuild = ({ tab }) => ({
  id: `69-${tab.name}`,
  reportId: HOTEL_ADS_REPORT_ID,
  scheduleTabs: tab.tabs ?? [],
  filters: tab.channel
    ? [{ field: 'marketing_channel', match_mode: 'equals', value: tab.channel }]
    : [],
  view: 'table',
  composition: 'chart-table',
  chartDimensions: ['hotel_name', 'hotel_image_url'],
  chartMetrics: ['cost', 'impressions', 'clicks'],
  sortField: 'mp_hotel_purchase',
})

export const HOTEL_ADS: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'reports.hotelAds.tabs.overview',
    sections: [
      {
        id: '69',
        titleKey: 'reports.hotelAds.overview.title',
        reportId: HOTEL_ADS_REPORT_ID,
        showDatePicker: true,
        defaultPreset: 'Last 7 Days',
        tabs: [
          { name: 'Overall', tabs: ['overview'] },
          { name: 'Google', tabs: ['google_ads_hotel'], channel: 'google_ads' },
          { name: 'Ga4', tabs: ['metrics_mp_hotel'], channel: 'ga4' },
          { name: 'Trivago', tabs: ['trivago_hotel'], channel: 'trivago' },
        ],
        build: hotelAdsBuild,
      },
    ],
  },
]
